//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/TransientObject.js";
let d=[[[0,"DescriptiveName",1,0],[0,"ParameterName",1,0],[0,"ParameterStatus",1,0],[0,"ParameterValue",1,0]],[[[],"Dispose",{},0,0],[["count","paraValues"],"GetValueList",{},0,0],[["parameterStatus"],"HasStatus",{R_:{hasStatus:''}},1,0]],[]];
SPLM.Tooling.SpreadsheetDataParameter = class extends SPLM.TransientObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.SpreadsheetDataParameter";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.SpreadsheetDataParameter.Status = Object.freeze({
    "Lock" : "Lock", "SystemKey" : "SystemKey", "UserKey" : "UserKey", "HideStatus" : "HideStatus", "ScaleItem" : "ScaleItem", "ReadOnly" : "ReadOnly", "Modified" : "Modified", "ForceColor" : "ForceColor", "HiddenValue" : "HiddenValue", "OptionValue" : "OptionValue", "NonStandardValue" : "NonStandardValue", "ShipRule" : "ShipRule"});

export default SPLM;